import React from 'react'
import './index.css'

const Roller = () => {
  return (
    <div className="center">
      <div className="lds-roller">
        <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
      </div>
    </div>
  )
}

export default Roller